import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=4c4db96c&"
import script from "./AlertModal.vue?vue&type=script&lang=js&"
export * from "./AlertModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports